export default
    {
        path:'/login',
        component: require('./index').default,
        name:'login'
    }
